module.exports = __webpack_public_path__ + "img/beta-tile-mobile.be288ee.jpg";